// removed by extract-text-webpack-plugin
module.exports = {"tiny":"380px","mobile":"768px","medium":"769px","large":"1013px"};


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/merchantcard/MerchantCardPage.scss
// module id = 1240
// module chunks = 0